module.exports = __webpack_public_path__ + "static/media/english.3e55d27c.svg";